import { render } from "./FollowButton.vue?vue&type=template&id=426ba0ae&scoped=true"
import script from "./FollowButton.vue?vue&type=script&lang=js"
export * from "./FollowButton.vue?vue&type=script&lang=js"

import "./FollowButton.vue?vue&type=style&index=0&id=426ba0ae&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426ba0ae"],['__file',"resources/js/components/FollowButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "426ba0ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('426ba0ae', __exports__)) {
    api.reload('426ba0ae', __exports__)
  }
  
  module.hot.accept("./FollowButton.vue?vue&type=template&id=426ba0ae&scoped=true", () => {
    api.rerender('426ba0ae', render)
  })

}


export default __exports__